module.exports = __webpack_public_path__ + "img/phone.ea782108.png";